import { render } from "./MessageHandle.vue?vue&type=template&id=d0c7638a&scoped=true&ts=true"
import script from "./MessageHandle.vue?vue&type=script&lang=ts"
export * from "./MessageHandle.vue?vue&type=script&lang=ts"

import "./MessageHandle.vue?vue&type=style&index=0&id=d0c7638a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0c7638a"]])

export default __exports__